var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.435,
    height: 40,
    viewBox: "0 0 40.435 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel_icon",
    transform: "translate(-3 -3.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M59.759,11.5H42V42.646H59.759a1.093,1.093,0,0,0,1.093-1.093V12.593A1.093,1.093,0,0,0,59.759,11.5Z",
    transform: "translate(-17.69 -3.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M27,43.342,3.5,38.971V8.371L27,4Z",
    transform: "translate(-0.227 -0.273)",
    fill: "#b7dbba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M21.882,41.3l-2.634-4.983a4.072,4.072,0,0,1-.311-1.027h-.044a7.661,7.661,0,0,1-.35,1.093L15.894,41.3h-4.1l4.874-7.65L12.205,26H16.4l2.186,4.584a7.144,7.144,0,0,1,.459,1.29h.044c.087-.3.246-.743.481-1.333L22,26h3.825l-4.568,7.584L25.97,41.3Z",
    transform: "translate(-3.987 -10.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M60,25.825H51.8V22H60Zm-7.65-.546h7.1V22.546h-7.1Zm-2.186.546H46.75v-.546h2.869V22.546H46.75V22h3.415ZM60,31.289H51.8V27.464H60Zm-7.65-.546h7.1V28.011h-7.1ZM60,36.753H51.8V32.928H60Zm-7.65-.546h7.1V33.475h-7.1Zm-2.186-4.918H46.75v-.546h2.869V28.011H46.75v-.546h3.415Zm0,5.464H46.75v-.546h2.869V33.475H46.75v-.546h3.415ZM60,42.217H51.8V38.393H60Zm-7.65-.546h7.1V38.939h-7.1Zm-2.186.546H46.75v-.546h2.869V38.939H46.75v-.546h3.415Z",
    transform: "translate(-19.844 -8.438)",
    fill: "#e0e9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M25.78,35.042H21.693a.273.273,0,0,1-.244-.15l-2.639-5.257,0-.01c-.034-.075-.066-.15-.1-.226q-.051.142-.108.281l-2.616,5.211a.273.273,0,0,1-.244.15H11.633a.273.273,0,0,1-.233-.416l4.752-7.786-4.38-7.784a.272.272,0,0,1,.238-.407H16.2a.273.273,0,0,1,.249.161l2.186,4.858c.089.19.17.385.243.584.07-.19.149-.4.238-.616L21.558,18.8a.273.273,0,0,1,.244-.15h3.825a.273.273,0,0,1,.237.41l-4.488,7.719,4.64,7.851a.274.274,0,0,1-.236.413ZM21.862,34.5H25.3l-4.477-7.577a.271.271,0,0,1,0-.276L25.152,19.2H21.97L19.614,23.86c-.264.666-.4,1.07-.463,1.287a.273.273,0,0,1-.262.2.328.328,0,0,1-.309-.207,6.923,6.923,0,0,0-.442-1.24l-2.115-4.7H12.478l4.23,7.516a.274.274,0,0,1,0,.276L12.12,34.5h3.453L18.1,29.455a7.5,7.5,0,0,0,.328-1.034.273.273,0,0,1,.266-.21.324.324,0,0,1,.314.229,3.806,3.806,0,0,0,.288.954Zm24,8.2h-15.3v-.546h15.3a.821.821,0,0,0,.82-.82V12.366a.821.821,0,0,0-.82-.82H30.288V11H45.861a1.368,1.368,0,0,1,1.366,1.366v28.96A1.367,1.367,0,0,1,45.861,42.692Z",
    transform: "translate(-3.792 -3.448)",
    fill: "#5d9874"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M27.042,43.4,3,38.925V7.871L27.042,3.4ZM3.546,38.47,26.5,42.74V4.056L3.546,8.326Z",
    fill: "#5d9874"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5273140fb361871ecb10018e9697331a.svg";
export { ForwardRef as ReactComponent };